// IREP Brand Colors and Theme Constants

export const COLORS = {
  primary: '#E3165B',      // Contisoft brand magenta
  success: '#22B24B',      // Contisoft success green
  warning: '#FFCA1C',      // Contisoft amber accent
  secondary: '#0378D5',    // Contisoft brand blue
  blue: '#0378D5',         // Brand blue alias
  // Vibrant chart colors
  chart: {
    blue: '#3B82F6',       // Bright Blue
    green: '#10B981',      // Emerald Green
    purple: '#8B5CF6',     // Purple
    pink: '#EC4899',        // Pink
    orange: '#F59E0B',      // Amber
    teal: '#14B8A6',       // Teal
    red: '#EF4444',        // Red
    indigo: '#6366F1',     // Indigo
    cyan: '#06B6D4',       // Cyan
    yellow: '#EAB308',     // Yellow
  },
  gray: {
    50: '#F5F5F5',
    100: '#E0E0E0',
    200: '#C0C0C0',
    300: '#A0A0A0',
    500: '#4C4C4C',
    600: '#404040',
    700: '#303030',
    900: '#1A1A1A',
  },
};

// Colorful palette for charts (ensures good contrast and visibility)
// Updated to match UI theme with better color harmony
export const CHART_COLORS = [
  '#E3165B',     // Brand magenta
  '#0378D5',     // Brand blue
  '#22B24B',     // Brand green
  '#FFCA1C',     // Brand yellow
  '#AB1145',     // Deep magenta
  '#0383E9',     // Bright blue
  '#74C72C',     // Lime green
  '#FF7E14',     // Orange accent
  '#EF5B8D',     // Soft pink
  '#2EA1FC',     // Sky blue
];

export const BRAND_NAME = 'IREP Analytics';
export const BRAND_TAGLINE = 'Global Facilities Management';

